// Generated by purs version 0.13.8
"use strict";
var Control_Monad_Trans_Class = require("../Control.Monad.Trans.Class/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var ManageProjects = function (Monad0, cloneProject, createProject, deleteProject, getProject, getProjects, saveProject) {
    this.Monad0 = Monad0;
    this.cloneProject = cloneProject;
    this.createProject = createProject;
    this.deleteProject = deleteProject;
    this.getProject = getProject;
    this.getProjects = getProjects;
    this.saveProject = saveProject;
};
var saveProject = function (dict) {
    return dict.saveProject;
};
var getProjects = function (dict) {
    return dict.getProjects;
};
var getProject = function (dict) {
    return dict.getProject;
};
var deleteProject = function (dict) {
    return dict.deleteProject;
};
var createProject = function (dict) {
    return dict.createProject;
};
var cloneProject = function (dict) {
    return dict.cloneProject;
};
var manageUserHalogenM = function (dictManageProjects) {
    return new ManageProjects(function () {
        return Halogen_Query_HalogenM.monadHalogenM;
    }, (function () {
        var $2 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageProjects.Monad0());
        var $3 = cloneProject(dictManageProjects);
        return function ($4) {
            return $2($3($4));
        };
    })(), (function () {
        var $5 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageProjects.Monad0());
        var $6 = createProject(dictManageProjects);
        return function ($7) {
            return $5($6($7));
        };
    })(), (function () {
        var $8 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageProjects.Monad0());
        var $9 = deleteProject(dictManageProjects);
        return function ($10) {
            return $8($9($10));
        };
    })(), (function () {
        var $11 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageProjects.Monad0());
        var $12 = getProject(dictManageProjects);
        return function ($13) {
            return $11($12($13));
        };
    })(), Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageProjects.Monad0())(getProjects(dictManageProjects)), (function () {
        var $14 = saveProject(dictManageProjects);
        return function ($15) {
            return (function (v) {
                var $16 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageProjects.Monad0());
                return function ($17) {
                    return $16(v($17));
                };
            })($14($15));
        };
    })());
};
module.exports = {
    ManageProjects: ManageProjects,
    getProjects: getProjects,
    getProject: getProject,
    createProject: createProject,
    saveProject: saveProject,
    deleteProject: deleteProject,
    cloneProject: cloneProject,
    manageUserHalogenM: manageUserHalogenM
};
